import { observer } from 'mobx-react-lite';
import payeaseStore from '../../stores/payease.store';
import { IPass } from '../../payease.types';
import { cx, formatPrice, passFromPrice, passHasOptions } from '../../payease.utils';
import { SelectableCard } from '../ui/selectable-card/selectable-card';
import { SectionLabel } from '../ui/section-label/section-label';
import './pass-card.scss';

interface IPassCardProps {
  pass: IPass;
}

export const PassCard = observer(({ pass }: IPassCardProps) => {
  const isActive = pass.id === payeaseStore.selectedPassId;
  const hasOptions = passHasOptions(pass);
  const activeOption = isActive ? payeaseStore.selectedOption : null;
  const minPrice = passFromPrice(pass);

  return (
    <SelectableCard active={isActive} className="pass-card" onClick={() => payeaseStore.handlePassTap(pass)}>
      <div>
        <h3 className="pass-card__name">{pass.name}</h3>
        {pass.description && <p className="pass-card__description">{pass.description}</p>}
        {hasOptions && (
          <SectionLabel accent className="pass-card__options">
            {pass.options.length} options
          </SectionLabel>
        )}
      </div>
      <div className="pass-card__price-row">
        {activeOption?.label ? (
          <>
            <SectionLabel>{activeOption.label}</SectionLabel>
            <p className="pass-card__price pass-card__price--active">{formatPrice(activeOption.price)}</p>
          </>
        ) : (
          <p className={cx('pass-card__price', isActive && 'pass-card__price--active')}>
            {hasOptions ? 'from ' : ''}
            {formatPrice(minPrice)}
          </p>
        )}
      </div>
    </SelectableCard>
  );
});
